export default __webpack_public_path__ + "static/media/branches.6ed8f6f9.svg";